import route from '@/routes/route'
const RendererManagement = () => import('@/views/RendererManagement');
const ActionTemplate = () => import('@/components/ActionTemplate');
const EntityMap = () => import('@/components/EntityMap');
const Order = () => import('@/components/Order');
const Shipment = () => import('@/components/Shipment');
const Auth = () => import('@/components/Auth');
const Permission = () => import('@/components/Permission');
const User = () => import('@/components/User');
const ReferenceMatrix = () => import('@/components/ReferenceMatrix');
const Home = () => import('@/views');
const Bracs = () => import('@/components/Brac');
const Bundle = () => import('@/components/Bundle');
const BundleIndex = () => import('@/views/indexes/Bundle');
const Process = () => import('@/components/Process');
const OrderIndex = () => import('@/views/indexes/Order');
const ShipmentIndex = () => import('@/views/indexes/Shipment');
const OrderLineIndex = () => import('@/views/indexes/OrderLine');
const PackageIndex = () => import('@/views/indexes/Package');
//const Role = () => import('@/views/adds/Role');
import Role from '@/views/adds/Role';
const CommentIndex = () => import('@/views/indexes/Comment');
const Report = () => import('@/components/Report');
const Test = () => import('@/components/Test');
const Chart = () => import('@/components/Chart');
const Dashboard = () => import('@/components/Dashboard');
const DocumentRequest = () => import('@/components/DocumentRequest');
const DraftIndex = () => import('@/views/indexes/Draft');
const EdiLog = () => import('@/views/indexes/EdiLog');
const ErrorLog = () => import('@/views/indexes/ErrorLog');
const AutomationLog = () => import('@/views/indexes/AutomationLog');
const DocumentFilesIndex = () => import('@/views/indexes/DocumentFilesIndex');
const Trigger = () => import('@/views/adds/Trigger');
const HandlingUnit = () => import('@/components/HandlingUnit');
const Task = () => import('@/views/adds/Task');
const GroupParty = () => import('@/views/adds/GroupParty');
const GroupTask = () => import('@/views/adds/GroupTask');
const Quote = () => import('@/components/Quote');
const Package = () => import('@/components/Package');
const EmbeddedScopeError = () => import('@/components/EmbeddedScopeError');
const ExtraFieldsGroupsIndex = () => import('@/views/indexes/ExtraFieldsGroups');
const ScheduledAction = () => import('@/views/indexes/ScheduledAction');
/**
 * Override any entity route
 * by registering in this array
 * ----------------------------------------
 * @function
 */
export default [
  route('/auth/login', Auth, 'auth', null, { guest: true }),
  route('/:scope/DocumentFiles', DocumentFilesIndex, 'DocumentFiles.index'),
  route('/:scope/ActionTemplate/:item/edit', ActionTemplate, 'ActionTemplate.edit'),
  route('/:scope/ActionTemplate/add', ActionTemplate, 'ActionTemplate.add'),
  route('/:scope/Draft', DraftIndex, 'draft.index'),
  route('/:scope/Order', OrderIndex, 'order.index'),
  route('/:scope/Order/add', Order, 'order.add'),
  route('/:scope/Order/:item/edit', Order, 'order.edit'),
  route('/:scope/Order/:item/draft', Order, 'order.draft'),
  route('/:scope/Order/:item/view', Order, 'order.view'),
  route('/:scope/Shipment', ShipmentIndex, 'shipment.index'),
  route('/:scope/Shipment/add', Shipment, 'shipment.add'),
  route('/:scope/Shipment/:item/edit', Shipment, 'shipment.edit'),
  route('/:scope/Shipment/:item/draft', Shipment, 'shipment.draft'),
  route('/:scope/Shipment/:item/view', Shipment, 'shipment.view'),
  route('/:scope/Permission/add', Permission, 'Permission.add'),
  route('/:scope/User/add', User, 'user.add'),
  route('/:scope/User/:item/edit', User, 'user.edit'),
  route('/:scope/ReferenceMatrix/add', ReferenceMatrix, 'ReferenceMatrix.add'),
  route('/:scope/ReferenceMatrix/:item/edit', ReferenceMatrix, 'ReferenceMatrix.edit'),
  route('/:scope/Role/add', Role, 'role.add'),
  route('/:scope/Role/:item/edit', Role, 'role.edit'),
  route('/:scope/Comment', CommentIndex, 'comment.index'),
  route('/:scope', Home, 'home', null, { title: 'Workstation' }),
  route('/:scope/Brac/add', Bracs, 'Brac.add'),
  route('/:scope/Brac/:item/edit', Bracs, 'Brac.edit'),
  route('/:scope/Process/add', Process, 'Process.add'),
  route('/:scope/Process/:item/edit', Process, 'Process.edit'),
  route('/:scope/Report/add', Report, 'report.add'),
  route('/:scope/Report/:item/edit', Report, 'report.edit'),
  route('/:scope/Chart/add', Chart, 'chart.add'),
  route('/:scope/Chart/:item/edit', Chart, 'chart.edit'),
  route('/:scope/Dashboard/add', Dashboard, 'dashboard.add'),
  route('/:scope/Dashboard/:item/edit', Dashboard, 'dashboard.edit'),
  route('/:scope/DocumentRequest/add', DocumentRequest, 'DocumentRequest.add'),
  route('/:scope/DocumentRequest/:item/edit', DocumentRequest, 'DocumentRequest.edit'),
  route('/:scope/EdiLog', EdiLog, 'ediLog.index'),
  route('/:scope/ErrorLog', ErrorLog, 'errorLog.index'),
  route('/:scope/AutomationLog', AutomationLog, 'automationLog.index'),
  route('/:scope/Trigger/add', Trigger, 'trigger.add'),
  route('/:scope/Trigger/:item/edit', Trigger, 'trigger.edit'),
  route('/:scope/HandlingUnit/add', HandlingUnit, 'handlingUnit.add'),
  route('/:scope/HandlingUnit/:item/edit', HandlingUnit, 'handlingUnit.edit'),
  route('/:scope/Task/add', Task, 'task.add'),
  route('/:scope/Task/:item/edit', Task, 'task.edit'),
  route('/:scope/Bundle', BundleIndex, 'bundle.index'),
  route('/:scope/Bundle/add', Bundle, 'bundle.add'),
  route('/:scope/Bundle/:item/edit', Bundle, 'bundle.edit'),
  route('/:scope/ScheduledAction', ScheduledAction, 'scheduledAction.index'),
  // party group
  route('/:scope/GroupParty/add', GroupParty, 'GroupParty.add'),
  route('/:scope/GroupParty/:item/edit', GroupParty, 'GroupParty.edit'),
  // task group
  route('/:scope/GroupTask/add', GroupTask, 'GroupTask.add'),
  route('/:scope/GroupTask/:item/edit', GroupTask, 'GroupTask.edit'),
  route('/:scope/OrderLine', OrderLineIndex, 'orderLine.index'),
  route('/:scope/Quote/add', Quote, 'quote.add'),
  route('/:scope/Quote/:item/edit', Quote, 'quote.edit'),
  route('/:scope/Quote/:item/draft', Quote, 'quote.draft'),
  route('/:scope/Quote/:item/view', Quote, 'quote.view'),
  route('/:scope/Package', PackageIndex, 'package.index'),
  route('/:scope/Package/add', Package, 'package.add'),
  route('/:scope/Package/:item/edit', Package, 'package.edit'),
  route('/:scope/Package/:item/draft', Package, 'package.draft'),
  route('/:scope/Package/:item/view', Package, 'package.view'),
  route('/:scope/Group', ExtraFieldsGroupsIndex, 'group.index'),
  // Custom routes for portals.
  route('/:scope/Shipment/:portal', ShipmentIndex, 'shipment.portal'),
  route('/:scope/shipment/portal/:portal/add', Shipment, 'shipment.portal.add'),
  route('/:scope/shipment/portal/:portal/:item/edit', Shipment, 'shipment.portal.edit'),
  route('/:scope/order/:portal', OrderIndex, 'shipment.portal'),
  route('/:scope/order/portal/:portal/add', Order, 'order.portal.add'),
  route('/:scope/order/portal/:portal/:item/edit', Order, 'order.portal.edit'),
  // embedable routes
  route('/embeddable/scope-error', EmbeddedScopeError, 'embeddable.scope-error'),
  route('/:scope/embeddable/Shipment', ShipmentIndex, 'embeddable.shipment.index'),
  route('/:scope/embeddable/Shipment/add', Shipment, 'embeddable.shipment.add'),
  route('/:scope/embeddable/Shipment/:portal', ShipmentIndex, 'embeddable.shipment.portal'),
  route('/:scope/renderer-management', RendererManagement, 'renderer-management'),
]
